// extracted by mini-css-extract-plugin
export default {"button":"style__button___eTgQT","image":"style__image___QNghx","label":"style__label___HdOf_"};